import { createUppyPlugin } from '@hive/core';

export const UppyPlugin = createUppyPlugin({
  endpoint: import.meta.env.VITE_HIVE_API_URL,
  cookiesRule: 'include',
});
